/**
 * Plugin per l'installazione del componenente WorldMenu e del relativo modulo dello store
 * con le opzioni giuste
 */
import WorldHeadbar from '../components/WorldHeadbar.vue';
import HeadbarModule from '../storeModules/headbar';

export default {
  install(Vue, { store }) {
    /**
     * Deve essere necessariamente passata l'istanza di vuex store
     */
    if(!store) {
      throw new Error("Please provide vuex store");
    }

    /**
     * Registrazione del modulo dello store associato al menu
     */
    store.registerModule('headbar', HeadbarModule);

    /**
     * Registrazione componente del menu
     */
    Vue.component('world-headbar', WorldHeadbar);
  }
}